import { render, staticRenderFns } from "./SwappTasksDashboard.vue?vue&type=template&id=78e0f6a6&scoped=true&"
import script from "./SwappTasksDashboard.vue?vue&type=script&lang=js&"
export * from "./SwappTasksDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0f6a6",
  null
  
)

export default component.exports